module.exports = {
  theme: {
    mainsubcategorysbackground: "#FFFFFF",
    btnmainbackground: "#4062F6",
    btnmaintext: "#FFFFFF",
    btnsecondbackground: "#E3E8FE",
    btnsecondtext: "#627EF8",
    btnthirdbackground: "#E3E8FE",
    btnthirdtext: "#627EF8",
    btnthirdicon: "#95A8FA",
    btnoutlineborder: "#E3E8FE",
    btnoutlinebackground: "#FFFFFF",
    btnoutlinetext: "#627EF8",
    btnoutlineicon: "#627EF8",
    btnoutlineactiveborder: "#627EF8",
    btnoutlineactivebackground: "#E3E8FE",
    btnoutlineactivetext: "#627EF8",
    btnoutlineactiveicon: "#627EF8",
    btndestructivebackground: "#FEE3E3",
    btndestructivetext: "#F86262",
    btndestructiveicon: "#FBA2A2",
    bordermain: "#ECECEC",
    borderonbackground: "#CFD7F7",
    backgroundmain: "#4062f6",
    backgroundmodal: "#00000030",
    backgroundmodallayover: "#00000030",
    listsborder: "",
    listsbackground: "#FFFFFF",
    liststext: "#95A8FA",
    listscheckbackground: "#CFD7F7",
    listscheckborder: "#CFD7F7",
    listscheckicon: "#192040",
    listactiveprice: "#95A8FA",
    listactivepricetext: "#FFF",
    listsactivebackground: "#CFD7F7",
    listsactivetext: "#627EF8",
    listsactivecheckbackground: "#192040",
    listsactivecheckborder: "#192040",
    listsactivecheckicon: "#CFD7F7",

    text: "#4062f6",
    titlemain: "#707070",
    titlesecondary: "#CFD7F7",
    titlethird: "#CFD7F7",
    processtekst: "#000000",
    paymentloadingbackground: "#e2e8f0",
    buttonimgcolors: "#4062F6",
    itembackground: "#efefef",

    cardmainbackground: "#E3E8FE",
    cardsecondarybackground: "#ECECEC",
    paymentbtnbackground: "#4062F6",
    paymentbtntext: "#FFFFFF",
    paymentfloatbackground: "#E3E8FE",
    paymentfloatactivebackground: "#FFFFFF",
    tipsfloatbackground: "#E3E8FE",
    tabsbackground: "#E3E8FE",
    tabstext: "#627EF8",
    tabsactivebackground: "#4062F6",
    tabsactivetext: "#FFFFFF",
    tabsicon: "#4062F6",
    summbackground: "#E3E8FE",
    summchildrenbackground: "#F8FAFF",
    stepsbackground: "#E3E8FE",
    stepstext: "#95A8FA",
    stepsnumber: "#95A8FA",
    stepsline: "#E3E8FE",
    stepsactivebackground: "#95A8FA",
    stepsactivetext: "#4062F6",
    stepsactivenumber: "#fff",
  },
};
